import { styled } from 'src/styles/stitches.config'

export const StyledFeaturedContent = styled('div', {
    '@md': {
        width: 'calc(9 * $colWidth)',
    },
})
